import { ImageContentFit, ImageProps, ImageStyle } from 'expo-image'
import { StyleProp, ViewStyle } from 'react-native'
import { AnimatedStyle, SharedValue } from 'react-native-reanimated'
import { ImageAny } from '@ui/utils/image'

export type TileGlassProps = {
  children?: React.ReactNode
  className?: string
  blur?: number
  blurMode?: BlurMode
  blurStyle?: StyleProp<ImageStyle>
  blurWrapperStyle?: StyleProp<ViewStyle>
  blurClassName?: string
  blurContentFit?: ImageContentFit
  blurImageProps?: ImageProps
  imageStyle?: StyleProp<ImageStyle>
  imageWrapperStyle?: StyleProp<ViewStyle> | AnimatedStyle<ViewStyle>
  image?: ImageAny
  imageBlur?: ImageAny
  imageProps?: ImageProps
  gradient?: React.ReactNode
  animation?: SharedValue<number>
  onPressBackground?: string
  underBlurComponent?: React.ReactNode
  magicGlow?: boolean
  borderRadius?: number
  backgroundColor?: string
  /** Shows the hidden dev-only blur-mode toggle button. */
  isDev?: boolean
}

export const BlurMode = {
  backdropFilter: 'backdropFilter',
  blurRadius: 'blurRadius',
} as const

export type BlurMode = (typeof BlurMode)[keyof typeof BlurMode]
